import React from 'react'
import { useSelector } from 'react-redux'
import { Trans } from '@lingui/macro'

import { Button } from 'components/UI/Button/Button'
import { Alert } from 'components/UI/Alert/Alert'
import { IdCashDesksState } from 'model/dashboardCashDesks/dCashDesksReducer';
import {
    ClipboardListIcon,
    LocationMarkerIcon,
    MinusSmIcon,
    PencilIcon, PlayIcon,
    StopIcon,
    TagIcon
} from '@heroicons/react/outline';

// Type
export type typePopupDetails = {
    setOpenPopup: React.Dispatch<React.SetStateAction<boolean>>
}


// Component
export const PopupDetails: React.FC<typePopupDetails> = ({ setOpenPopup }) => {

    const dataObject = useSelector((state: { dCashDesks: IdCashDesksState }) => state.dCashDesks.detailItem)
    const dateCreated = dataObject!.dateCreated ? ( new Date(dataObject!.dateCreated) ).toISOString().substring(0,16).replace('T', ', ') : null
    const dateEdited = dataObject!.dateEdited ? ( new Date(dataObject!.dateEdited) ).toISOString().substring(0,16).replace('T', ', ') : null
    return (
        <>
            { dataObject
                ? <>
                    <div  className="mt-6 sm:mt-8 grid gap-x-8 grid-cols-1 sm:grid-cols-2 sm:border sm:rounded-md sm:px-4">

                        <div className="flex flex-wrap justify-between  gap-x-4 py-2 border-b border-t sm:border-t-0 sm:py-4">
                            <div className="flex gap-x-2 items-center text-gray-500 text-left">
                                <TagIcon className="h-5 w-5 text-gray-500"/>
                                <Trans>Cash Desk model:</Trans>
                            </div>
                            <div className="text-gray-90 text-right sm:text-left">{ dataObject.posHardwareModel? dataObject.posHardwareModel : <div className="flex "><MinusSmIcon className="h-5 w-5 text-gray-400"/></div> }</div>
                        </div>

                        <div className="flex flex-wrap  justify-between gap-x-4 py-2 border-b sm:py-4">
                            <div className="flex gap-x-2 items-center text-gray-500 text-left">
                                <TagIcon className="h-5 w-5 text-gray-500"/>
                                <Trans>Cash Desk SN:</Trans>
                            </div>
                            <div className="text-gray-90 text-right sm:text-left">{ dataObject.posHardwareSerialNumber? dataObject.posHardwareSerialNumber : <div className="flex "><MinusSmIcon className="h-5 w-5 text-gray-400"/></div> }</div>
                        </div>

                        {process.env.REACT_APP_CUSTOMER !== 'SKAPPSK' && <div className="flex flex-wrap justify-between  gap-x-4  py-2 border-b sm:py-4 sm:border-b-0">
                            <div className="flex gap-x-2 items-center text-gray-500 text-left">
                                <ClipboardListIcon className="h-5 w-5 text-gray-500"/>
                                <Trans>fiscal Card Id:</Trans>
                            </div>
                            <div
                                className="text-gray-90 text-right sm:text-left">{ dataObject.fiscalCardId ? dataObject.fiscalCardId :
                                <div className="flex "><MinusSmIcon className="h-5 w-5 text-gray-400"/></div> }</div>
                        </div> }

                        <div className="flex flex-wrap justify-between gap-x-4 py-2 border-b sm:py-4 sm:border-0">
                            <div className="flex gap-x-2 items-center text-gray-500 text-left">

                                <Trans>Status</Trans>:
                            </div>
                            <div className="text-gray-90 text-right sm:text-left font-bold">
                                { dataObject.blocked? <div className="flex justify-center" title={'blocked'}><StopIcon className="h-5 w-5 text-red-400"/></div>
                                    :<div className="flex justify-center" title={'not blocked'}><PlayIcon className="h-5 w-5 text-green-400"/></div> }
                            </div>
                        </div>

                    </div>
                    <div
                        className="mt-6 sm:mt-8 grid gap-x-8 grid-cols-1 sm:grid-cols-2 sm:border sm:rounded-md sm:px-4">
                        <div
                            className="flex flex-wrap justify-between gap-x-4 py-2 border-b  border-t sm:border-t-0 sm:py-4 ">
                            <div className="flex gap-x-2 items-center text-gray-500 text-left">
                                <PencilIcon className="h-5 w-5 text-gray-500"/>
                                <Trans>Store name:</Trans>
                            </div>
                            <div className="text-gray-90 text-right sm:text-left font-medium">{ dataObject.store? dataObject.store.name : <div className="flex "><MinusSmIcon className="h-5 w-5 text-gray-400"/></div> }</div>

                        </div>
                        <div className="flex flex-wrap justify-between gap-x-4 py-2 border-b sm:py-4 ">
                            <div className="flex gap-x-2 items-center text-gray-500 text-left">

                                <Trans>Cash desk number:</Trans>
                            </div>
                            <div className="text-gray-90 text-right sm:text-left font-bold">{ dataObject.posNumber? dataObject.posNumber:<div className="flex "><MinusSmIcon className="h-5 w-5 text-gray-400"/></div> }</div>
                        </div>

                        <div className="flex flex-wrap justify-between  gap-x-4 py-2 border-b sm:py-4 sm:border-0">
                            <div className="flex gap-x-2 items-center text-gray-500 text-left">
                                <LocationMarkerIcon className="h-5 w-5 text-gray-500"/>
                                <Trans>Store address:</Trans>
                            </div>
                            <div className="text-gray-90 text-right sm:text-left">{dataObject.store? dataObject.store.address : <div className="flex "><MinusSmIcon className="h-5 w-5 text-gray-400"/></div>}</div>
                        </div>
                    </div>
                    <div
                        className="mt-6 sm:mt-8 grid gap-x-8 grid-cols-1 sm:grid-cols-2 sm:border sm:rounded-md sm:px-4">
                        <div className="flex flex-wrap justify-between gap-x-4  py-2 border-b sm:py-4 sm:border-0 border-t sm:border-t-0 " >
                            <div className="flex gap-x-2 items-center text-gray-500 text-left">
                                <Trans>Creation time :</Trans>
                            </div>
                            <div className="text-gray-90 text-right sm:text-left">{ dataObject.dateCreated? dateCreated : '-' }</div>
                        </div>

                        <div className="flex flex-wrap justify-between gap-x-4  py-2 border-b sm:py-4 sm:border-0">
                            <div className="flex gap-x-2 items-center text-gray-500 text-left">
                                <Trans>Edit time :</Trans>
                            </div>
                            <div className="text-gray-90 text-right sm:text-left">{ dataObject.dateEdited? dateEdited : '-' }</div>
                        </div>

                    </div>


                    <div className="flex gap-4 mt-5 sm:mt-4 sm:flex sm:flex-row-reverse">
                        <Button type="button" secondary={ true } label={ <Trans>Close</Trans> }
                                onClick={ () => setOpenPopup(false) }/>
                    </div>

                </>
                : <Alert type="error" title={ <Trans>Have no data.</Trans> }/>
            }
        </>
    )
}
